import { Routes } from '@angular/router';
import { WebsiteLayoutComponent } from '../website-layout/website-layout.component';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { ThankYouComponent } from '../contact-us/thank-you/thank-you.component';
import { SignInComponent } from '../student-portal/sign-in/sign-in.component';
import { SignUpComponent } from '../student-portal/sign-up/sign-up.component';
import { SignUpThankYouComponent } from '../student-portal/sign-up-thank-you/sign-up-thank-you.component';
import { PeerSignupThankYouComponent } from '../peer-signup/peer-signup-thank-you/peer-signup-thank-you.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { PermissionGuard } from '../guards/permission.guard';
import { PayNowComponent } from '../pay-now/pay-now.component';
import { PaymentSuccessComponent } from '../pay-now/pay-success/payment-success.component';
import { PaymentFailureComponent } from '../pay-now/pay-failure/payment-failure.component';
import { PrivacyPolicyComponent } from '../website-layout/privacy-policy/privacy-policy.component';
import { ShopComponent } from '../student-portal/shop/shop.component';
import { ShopBillingComponent } from '../student-portal/shop-billing/shop-billing.component';
import { PeerSignupComponent } from '../peer-signup/peer-signup.component';
import { PartnerSignInComponent } from '../partner-portal/partner-sign-in/partner-sign-in.component';
import { LinkedinCallbackComponent } from '../student-portal/linkedin-callback/linkedin-callback.component';
import { PublicRoiCalculatorComponent } from '../public-roi-calculator/public-roi-calculator.component';

export const publicRoutes: Routes = [
  {
    path: '', component: WebsiteLayoutComponent,
    children: [
      {
        path: '', redirectTo: '/signin', pathMatch: 'full'
      },
      {
        path: 'contact-us', component: ContactUsComponent
      },
      {
        path: 'thank-you', component: ThankYouComponent
      },
      {
        path: 'pay-now', component: PayNowComponent,
      },
      {
        path: 'pay-success/:transactionId', component: PaymentSuccessComponent
      },
      {
        path: 'pay-failure/:transactionId', component: PaymentFailureComponent
      },
      {
        path: 'privacy-policy', component: PrivacyPolicyComponent
      },
      {
        path: 'shop', component: ShopComponent
      },
      {
        path: 'shop-billing', component: ShopBillingComponent
      },
      {
        path: 'peer-signup', component: PeerSignupComponent
      },
      {
        path: 'peer-signup-thank-you', component: PeerSignupThankYouComponent,
        canActivate: []
      },
      {
        path: 'roi-calculator', component: PublicRoiCalculatorComponent
      }
    ]
  },
  {
    path: 'signin', component: SignInComponent,
    canActivate: [PermissionGuard]
  },
  {
    path: 'partner-signin', component: PartnerSignInComponent,
    canActivate: [PermissionGuard]
  },
  {
    path: 'signup', component: SignUpComponent,
  },
  {
    path: 'student-signup',
    redirectTo: 'signup',
    pathMatch: 'full',
  },
  {
    path: 'signup-thank-you', component: SignUpThankYouComponent,
    canActivate: []
  },
  {
    path: 'forgot-password', component: ForgotPasswordComponent
  },
  {
    path: 'linkedin-callback', component: LinkedinCallbackComponent
  }
];
